import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function fmt(num) {
  if (num === null || num === undefined) return "₲ 0";
  return "₲ " + Math.round(num).toLocaleString("es-PY");
}

export function fmtDate(dateStr) {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleDateString("es-PY", {
    day: "2-digit", month: "2-digit", year: "numeric"
  });
}

export function fmtDatetime(dateStr) {
  if (!dateStr) return "-";
  return new Date(dateStr).toLocaleString("es-PY", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit"
  });
}

export const ESTADO_RECEPCION_LABEL = {
  INGRESADO: "Ingresado",
  EN_PRESUPUESTO: "En Presupuesto",
  APROBADO: "Aprobado",
  EN_PROCESO: "En Proceso",
  CONTROL_CALIDAD: "Control Calidad",
  LISTO: "Listo",
  ENTREGADO: "Entregado",
  CANCELADO: "Cancelado",
};

export const ESTADO_ORDEN_LABEL = {
  PENDIENTE: "Pendiente",
  EN_PROCESO: "En Proceso",
  CONTROL_CALIDAD: "Control Calidad",
  LISTO: "Listo",
  ENTREGADO: "Entregado",
};

export const ESTADO_PRESUPUESTO_LABEL = {
  BORRADOR: "Borrador",
  ENVIADO: "Enviado",
  APROBADO: "Aprobado",
  RECHAZADO: "Rechazado",
};

export const ESTADO_FACTURA_LABEL = {
  PENDIENTE: "Pendiente",
  COBRADO: "Cobrado",
  ANULADA: "Anulada",
};

// Mapa unificado de etiquetas para todos los tipos de estado
export const ESTADO_LABEL = {
  // Recepción
  INGRESADO: "Ingresado",
  EN_PRESUPUESTO: "En Presupuesto",
  APROBADO: "Aprobado",
  EN_PROCESO: "En Proceso",
  CONTROL_CALIDAD: "Control Calidad",
  LISTO: "Listo",
  ENTREGADO: "Entregado",
  CANCELADO: "Cancelado",
  // Presupuesto
  BORRADOR: "Borrador",
  ENVIADO: "Enviado",
  RECHAZADO: "Rechazado",
  // Factura
  PENDIENTE: "Pendiente",
  COBRADO: "Cobrado",
  ANULADA: "Anulada",
};

export const ESTADO_COLOR = {
  INGRESADO: "bg-blue-100 text-blue-800",
  EN_PRESUPUESTO: "bg-purple-100 text-purple-800",
  APROBADO: "bg-green-100 text-green-800",
  EN_PROCESO: "bg-yellow-100 text-yellow-800",
  CONTROL_CALIDAD: "bg-orange-100 text-orange-800",
  LISTO: "bg-emerald-100 text-emerald-800",
  ENTREGADO: "bg-gray-100 text-gray-700",
  CANCELADO: "bg-red-100 text-red-800",
  PENDIENTE: "bg-yellow-100 text-yellow-800",
  BORRADOR: "bg-gray-100 text-gray-700",
  ENVIADO: "bg-blue-100 text-blue-800",
  RECHAZADO: "bg-red-100 text-red-800",
  COBRADO: "bg-green-100 text-green-800",
  ANULADA: "bg-red-100 text-red-800",
};
